// Filename - components/Sidebar/SidebarData.js


import React from "react";
import announcementLogo from "../../../../img/wd-applet-announcements.png";
import compensationLogo from "../../../../img/wd-applet-compensation.png";
import opportunityLogo from "../../../../img/wd-applet-opportunity-graph.png"
import payrollLogo from "../../../../img/wd-applet-payroll-year-end.png";
import financialsLogo from "../../../../img/wd-applet-financials.png"
import learningLogo from "../../../../img/wd-applet-learning.png"
import dashboardLogo from "../../../../img/wd-applet-custom-dashboards-talent-management.png"

// Each label names the page it opens (QA issue 4).
export const SidebarData = [
    {
        title: "Benefits",
        path: "/benefits",
        icon: <img alt="" style={{height: "32.77px", width: "auto"}} src={compensationLogo}></img>
    },
    //Non-functional links are REMOVED but can be re-added later
    /*{
        title: "Conflict of Interest",
        path: "/",
        icon: <img style={{height: "32.77px", width: "auto"}} src={announcementLogo}></img>
    },*/
    {
        title: "Career",
        path: "/career",
        icon: <img alt="" style={{height: "32.77px", width: "auto"}} src={opportunityLogo}></img>
    },
    /*{
        title: "Team Talent and Performance",
        path: "/",
        icon: <img style={{height: "32.77px", width: "auto"}} src={dashboardLogo}></img>
    },*/
    /*{
        title: "Learning",
        path: "/",
        icon: <img style={{height: "32.77px", width: "auto"}} src={learningLogo}></img>
    },*/
    {
        title: "Pay",
        path: "/pay",
        icon: <img alt="" style={{height: "32.77px", width: "auto"}} src={financialsLogo}></img>
    },
    {
        title: "Absence",
        path: "/absence",
        icon: <img alt="" style={{height: "32.77px", width: "auto"}} src={payrollLogo}></img>
    },

];
